import { Loader } from '@calendly/ui/components/loader';
import classNames from 'classnames';
import { forwardRef } from 'react';
const loaderContainerCss = "lff30q1";
export const LoaderContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(loaderContainerCss, props.className)}>
      <Loader data-testid="loader" />
    </Component>;
});
const churnLoaderContainerCss = "c1o3tc8m";
export const ChurnLoaderContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(churnLoaderContainerCss, props.className)}>
      <Loader data-testid="loader" />
    </Component>;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");